<template>
  <section :class="{invisible : !activeNav}" class="screen">

  <div @click="$router.push('/timeline')" class="tab schedule">
    <h2>My<br>Schedule</h2>

  </div>

  <div @click="$router.push('/patients')" class="tab patient">
    <h2>Patient<br>Database</h2>
  </div>

  <div @click="$router.push('/services/')" class="tab treatment">
    <h2>Add Services</h2>
  </div>

  <div @click="$router.push('/messages/' + user.uid)" class="tab messages">
    <h2>My<br>Messages</h2>
  </div>

  <div class="tab escripts" @click="$router.push('/report-problem')">
    <h2>Report Problem</h2>
  </div>

  <!-- <div class="tab insurance">
    <h2>Insurance<br>Claims</h2>
  </div> -->

  <div class="tab office">
    <h2>Office<br>Profile</h2>
  </div>

<!-- user for loop -->
    <!-- <div v-for="(display, idx) in users" class="tab" :key="idx" @click="$router.push('/user/' + display.uid)">
        <div class="tab__type bg-12"></div>
        <div class="tab__name">{{ display.displayName}}</div>
    </div> -->

<!-- <div class="tab">
          <div class="tab__type orange"></div>
          <div class="tab__name">Suggested Treatment</div>
          <div class="tab__description">Implant tooth #19</div>
      </div>
    <div class="tab" @click="$router.push('/scheduled')">
          <div class="tab__type yellow"></div>
          <div class="tab__name">SCHEDULED - Cleaning</div>
          <div class="tab__description">January 12th, 2016 (10am)</div>
      </div>
    <div class="tab">
          <div class="tab__type media">
              <img src="/static/media.svg">
          </div>
          <div class="tab__name">New visual media added</div>
          <div class="tab__description">8-23-19</div>
      </div>
    <div class="tab">
          <div class="tab__type grey"></div>
          <div class="tab__name">Prescripiton updated</div>
          <div class="tab__description">PAST - March 18th - 2018</div>
      </div>
      <div class="tab">
          <div class="tab__type grey"></div>
          <div class="tab__name">Suggested Treatment</div>
          <div class="tab__description">Implant tooth #19</div>
      </div>
      <div class="tab">
          <div class="tab__type grey"></div>
          <div class="tab__name">Suggested Treatment</div>
          <div class="tab__description">Implant tooth #19</div>
      </div>
      <div class="tab">
          <div class="tab__type grey"></div>
          <div class="tab__name">Suggested Treatment</div>
          <div class="tab__description">Implant tooth #19</div>
      </div>
    <div class="tab">
          <div class="tab__type grey"></div>
          <div class="tab__name">Suggested Treatment</div>
          <div class="tab__description">Implant tooth #19</div>
      </div> -->



  </section>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
import { page } from 'vue-analytics'
import AOS from '../main'
import { firestore } from "../main"
import * as firebase from "firebase"
import { mapMutations, mapGetters } from 'vuex'
import { Kalendar } from 'kalendar-vue';
import 'kalendar-vue/dist/KalendarVue.css'

console.log(Kalendar)

export default {
  name: 'timeline',
  data () {
    return {
		events: ['event: 1'],
		calendar_settings: {
			style: 'material_design',
			view_type: 'week',
			cell_height: 5,
			scrollToNow: true,
			current_day: new Date(),
			read_only: false,
			day_starts_at: 0,
      			day_ends_at: 24,
      			overlap: true,
      			hide_dates: ['2019-10-31'], // Spooky
      			hide_days: [6],
      			past_event_creation: true
		},
        new_appointment: {
          title: 'trial',
          description: 'need more info'
        },
    users: {}
    }
  },
firestore() {
    return {
      users: firestore.collection('users')
  }
},
components: {
  Kalendar
},
  watch: {

  },
  methods: {
    ...mapMutations([
      'logModules',
      'logIn',
      'logOut',
      'logInGoogle'
    ])
  },
  computed: {
    ...mapGetters([
      'loggedIn',
      'user',
      'isLoading',
      'activeNav'
    ]),
    addEvent(popup_data, form_data) {
  let payload = {
    data: {
      title: this.new_appointment.title,
      description: this.new_appointment.description,
    },
    from: popup_info.start_time,
    to: popup_info.end_time,
  };

  this.$kalendar.addNewEvent(
    payload,
  );
  this.$kalendar.closePopups();
  this.clearFormData();
},

// Remove Event
removeEvent(kalendarEvent) {
  let day = kalendarEvent.start_time.slice(0, 10);
  this.$kalendar.removeEvent({
    day,
    key: kalendarEvent.key,
    id: kalendarEvent.kalendar_id,
  })
}
  }
}
</script>

<style lang="scss" scoped>

  $break-small: 900px;
  $brandColor: #29aad0;
  $brandColorTwo: #70c8df;
  $accentColor: #de7c5e;


.screen {
    left: 50vh;
    top: 50vh;
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    padding: 80px 0;
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    align-items: center;
    opacity: 1;
    transition: .7s ease-in-out;


    .schedule {
      background-color: #D7D4FF;
    }
    .progress {
      background-color: #00D194;
    }
    .treatment {
      background-color: #B5F5E6;
    }
    .messages {
      background-color: #FFEEBC;
    }
    .escripts {
      background-color: #D7D4FF;
    }
    .patient {
      background-color: #FFCFBF;
    }
    .insurance {
      background-color: #FFCFBF;
    }
    .office {
      background-color: #E8EDED;
    }
    .tab {
        width: 24vw;
        height: 20vw;
        padding: 20px 30px;
        border-radius: 20px;
        margin: 1vw auto;
        display: flex;
        flex-direction: column;
        position: relative;
        align-items: left;
        justify-content: center;
        color: #333;
        cursor: pointer;
        @media screen and (max-width: $break-small) {
          width: 44vw;
          height: 42vw;
          margin: 3vw auto;
        }

        &:hover {
            // opacity: 0.9;
        }

        h2 {
          font-size: 1.5vw;
          text-align: left;
          text-transform: uppercase;
          font-family: "futura", sans-serif;
          font-weight: 500;
          letter-spacing: 1px;
          @media screen and (max-width: $break-small) {
            font-size: 3vw;

          }
        }
 
        &__type {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            position: absolute;
            top: calc(50% - 7.5px);
            left: 20px;
        }

            // sub settings of type
            .orange {
                background-color: $accentColor;
            }
            .yellow {
                background-color: #f8e85b;
            }
            .media {
                width: 30px;
                height: 30px;
                margin-left: -5px;
                img {
                    width: 20px;
                }
            }
            .grey {
                background-color: #ddd;
            }
        &__name {
            width: 70%;
            text-align: left;
            font-weight: 600;
            font-size: 16px;
        }
        &__description{
            width: 70%;
            text-align: left;
            font-weight: 300;
            font-size: 14px;
            font-style: italic;
            padding: 2px 0;
        }
    }
    
}
.invisible {
  opacity: 0;
  transition: 0.7s ease-in-out;
  left: 20vh;
}

  
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue